import {
    canModerateForumAction,
    hydrateTreeForumIfNeededAction,
    _treeForumPlaceKeyAction,
    _isoWeekKeyAction,
    ensureTreeForumPlaceLoadedAction,
    ensureTreeForumThreadLoadedAction,
    ensureTreeForumThreadWeekLoadedAction,
    getLoadedForumThreadWeeksAction,
    getTreeForumThreadWeeksAction,
    searchTreeForumV3Action,
} from './forum-nostr-load-store-actions.js';
import {
    _forumModerationCacheKeyAction,
    getForumModerationModeForActiveTreeAction,
    invalidateForumModerationCacheAction,
    setForumModerationPolicyModeAction,
    listForumPendingSummariesForActiveTreeAction,
    approveForumPendingMessageAction,
    rejectForumPendingMessageAction,
} from './forum-nostr-moderation-store-actions.js';
import {
    publishSignedForumMessageV3Action,
    addForumThreadAction,
    addForumMessageAction,
} from './forum-nostr-post-store-actions.js';
import {
    setForumBanForActiveTreeAction,
    selfDeleteForumMessageAction,
    moderateDeleteForumMessageAction,
    moderateDeleteForumThreadAction,
} from './forum-nostr-admin-store-actions.js';

export {
    canModerateForumAction,
    hydrateTreeForumIfNeededAction,
    _treeForumPlaceKeyAction,
    _isoWeekKeyAction,
    ensureTreeForumPlaceLoadedAction,
    ensureTreeForumThreadLoadedAction,
    ensureTreeForumThreadWeekLoadedAction,
    getLoadedForumThreadWeeksAction,
    getTreeForumThreadWeeksAction,
    searchTreeForumV3Action,
    _forumModerationCacheKeyAction,
    getForumModerationModeForActiveTreeAction,
    invalidateForumModerationCacheAction,
    setForumModerationPolicyModeAction,
    listForumPendingSummariesForActiveTreeAction,
    approveForumPendingMessageAction,
    rejectForumPendingMessageAction,
    publishSignedForumMessageV3Action,
    addForumThreadAction,
    addForumMessageAction,
    setForumBanForActiveTreeAction,
    selfDeleteForumMessageAction,
    moderateDeleteForumMessageAction,
    moderateDeleteForumThreadAction,
};

/** Store.prototype, explicit actions (no bindStoreContext). */
export const storeNostrForumMethods = {
    canModerateForum: canModerateForumAction,
    hydrateTreeForumIfNeeded: hydrateTreeForumIfNeededAction,
    _treeForumPlaceKey: _treeForumPlaceKeyAction,
    _isoWeekKey: _isoWeekKeyAction,
    ensureTreeForumPlaceLoaded: ensureTreeForumPlaceLoadedAction,
    ensureTreeForumThreadLoaded: ensureTreeForumThreadLoadedAction,
    ensureTreeForumThreadWeekLoaded: ensureTreeForumThreadWeekLoadedAction,
    getLoadedForumThreadWeeks: getLoadedForumThreadWeeksAction,
    getTreeForumThreadWeeks: getTreeForumThreadWeeksAction,
    searchTreeForumV3: searchTreeForumV3Action,
    _forumModerationCacheKey: _forumModerationCacheKeyAction,
    getForumModerationModeForActiveTree: getForumModerationModeForActiveTreeAction,
    invalidateForumModerationCache: invalidateForumModerationCacheAction,
    setForumModerationPolicyMode: setForumModerationPolicyModeAction,
    listForumPendingSummariesForActiveTree: listForumPendingSummariesForActiveTreeAction,
    approveForumPendingMessage: approveForumPendingMessageAction,
    rejectForumPendingMessage: rejectForumPendingMessageAction,
    publishSignedForumMessageV3: publishSignedForumMessageV3Action,
    addForumThread: addForumThreadAction,
    addForumMessage: addForumMessageAction,
    setForumBanForActiveTree: setForumBanForActiveTreeAction,
    selfDeleteForumMessage: selfDeleteForumMessageAction,
    moderateDeleteForumMessage: moderateDeleteForumMessageAction,
    moderateDeleteForumThread: moderateDeleteForumThreadAction,
};
